const mapChildArrayToObjects = (data, Type) => data && Array.isArray(data)? 
    data.map(itm=> new Type(itm)) : data || []

export {mapChildArrayToObjects}